import { render } from "./ProfileMenu.vue?vue&type=template&id=0943ffd6&scoped=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&lang=js"

import "./ProfileMenu.vue?vue&type=style&index=0&id=0943ffd6&lang=scss"
import "./ProfileMenu.vue?vue&type=style&index=1&id=0943ffd6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0943ffd6"]])

export default __exports__